import { connect } from 'react-redux';

import { SECTION_ID_NEARBY_PROPERTIES } from 'legacy/appstore/constants';

import {
  CHART_DATA_VALUE_FNS,
  NEARBY_CHART_ORDER
} from 'legacy/services/chart-data';

import { buildChartConfigNearbyProperties } from 'legacy/utils/chart-configs';

import { changeGlossarySelected } from 'actions/support';
import {
  chartDataNeighborhoodChartDataSelect,
  chartDataNeighborhoodChartTypeSelect
} from 'actions/chart-data';

import {
  getChartDataNeighborhoodSelected,
  getChartDataSelectedSubjectValue,
  getChartDataSelectedNeighborhoodDataKey,
  getChartDataSelectedNeighborhoodChartType
} from 'selectors/chart-data';
import { getReportStatusNearbyPropertiesIsLoadedInitial } from 'selectors/report-status';

import loadWhenReady from 'legacy/hocs/loadWhenReady';

import NearbyPropertiesSection from 'legacy/components/NearbyPropertiesSection';

const mapStateToProps = (state) => {
  const chartType = getChartDataSelectedNeighborhoodChartType(state);
  const chartData = getChartDataNeighborhoodSelected(state);
  const chartDataKeySelected = getChartDataSelectedNeighborhoodDataKey(state);
  const subjectValue = getChartDataSelectedSubjectValue(state);
  let toggleOptions = [];

  for (let i in NEARBY_CHART_ORDER) {
    const chartType = NEARBY_CHART_ORDER[i];
    if (chartData[chartType]) {
      toggleOptions.push({
        dataHcName: 'nearby-properties-charts-label',
        value: chartType,
        label: CHART_DATA_VALUE_FNS[chartType].labelAbbrv
      });
    }
  }
  return {
    chartType,
    isReportLoaded: getReportStatusNearbyPropertiesIsLoadedInitial(state),
    hasChartData:
      chartData &&
      chartData[chartDataKeySelected] &&
      chartData[chartDataKeySelected].length,
    chartDataKeySelected,
    toggleOptions,
    chartConfig: buildChartConfigNearbyProperties(
      chartData,
      chartType,
      chartDataKeySelected,
      subjectValue
    )
  };
};

const mapDispatchToProps = (dispatch) => ({
  onChangeChartType: (chartType) =>
    dispatch(chartDataNeighborhoodChartTypeSelect(chartType)),
  handleClickInfoButton: () =>
    dispatch(changeGlossarySelected(['NEAR_BY_PROPERTIES'])),
  onChangeSelectedData: (key) =>
    dispatch(chartDataNeighborhoodChartDataSelect(key))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(loadWhenReady(NearbyPropertiesSection, SECTION_ID_NEARBY_PROPERTIES));
